var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "side-panel",
    { on: { close: _vm.close } },
    [
      _c("template", { slot: "header" }, [
        !_vm.addressId
          ? _c("h3", { staticClass: "mt-0 clearfix" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$l10n.__("Ajouter une adresse")) +
                  "\n        "
              )
            ])
          : _c("h3", { staticClass: "mt-0 clearfix" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$l10n.__("Modifier l'adresse")) +
                  "\n        "
              )
            ])
      ]),
      _vm._v(" "),
      _c(
        "template",
        { staticClass: "prelative", slot: "content" },
        [
          _c("preloader", { attrs: { display: _vm.loading } }),
          _vm._v(" "),
          !_vm.loading
            ? _c(
                "div",
                [
                  _c("p", { staticClass: "gray-60" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$l10n.__(
                            "Définissez un nom pour votre adresse et ainsi mieux l'identifier"
                          )
                        ) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    {
                      ref: "addressForm",
                      attrs: {
                        "label-position": "top",
                        model: _vm.address,
                        rules: _vm.rules,
                        "label-width": "120px"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t.__("common.labels.address_name"),
                            prop: "label",
                            error: _vm.errors.get("label")
                          }
                        },
                        [
                          _c("text-input", {
                            attrs: {
                              mode: _vm.mode,
                              placeholder: _vm.$t.__(
                                "common.labels.address_name"
                              )
                            },
                            model: {
                              value: _vm.address.label,
                              callback: function($$v) {
                                _vm.$set(_vm.address, "label", $$v)
                              },
                              expression: "address.label"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t.__("common.labels.address") }
                        },
                        [
                          _c("address-input", {
                            model: {
                              value: _vm.address,
                              callback: function($$v) {
                                _vm.address = $$v
                              },
                              expression: "address"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "footer" },
        [
          _c("CompassButton", {
            attrs: {
              label: _vm.$t.__("common.actions.cancel"),
              type: "secondary"
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.close($event)
              }
            }
          }),
          _vm._v(" "),
          _c("CompassButton", {
            staticClass: "ml-3",
            attrs: { label: _vm.$t.__("common.actions.save") },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.submitForm("addressForm")
              }
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }